module.exports = __webpack_public_path__ + "img/ios.f059e6c8.png";